"use client";
import { TanStackDevtools as TanStackDevtools$1 } from "./devtools.js";
const TanStackDevtools = TanStackDevtools$1;
export {
  TanStackDevtools
};
//# sourceMappingURL=index.js.map
